import { findIndex } from 'lodash';
import { MutableRefObject } from 'react';

import { IConversationMessage } from '@/utils/conversation/types';

export interface IManuallyAlterMessageProps {
  message: IConversationMessage;
  cachedMessagesRef: MutableRefObject<Array<IConversationMessage>>;
}

export const findLastReplyIndex = (messages, parentMessageId) => {
  return findIndex(messages, (m: IConversationMessage) => {
    // if the message has no replies, we want the index of parent message
    const isParentMessage = m.sid === parentMessageId;
    const isParentMessageReply = m.attributes?.parentMessageId === parentMessageId;

    // since the replies always come AFTER the parent message,
    // and this function returns LAST index that satisfies the condition
    // we can safely do this:
    return isParentMessage || isParentMessageReply;
  });
};

export const manuallyRemoveMessage = (props: IManuallyAlterMessageProps) => {
  const { message, cachedMessagesRef } = props;

  cachedMessagesRef.current = cachedMessagesRef.current.filter((m: IConversationMessage) => {
    return m.sid !== message.sid || message.sid === message.attributes?.parentMessageId;
  });
};
